export enum Terms {
  TUTORIAL_CATEGORY = 'tutorial-category',
  COURSE_TOPIC = 'course-topic',
  COURSE_SECTOR = 'course-sector',
  COURSE_FORMATION_TYPE = 'course-formation-type',
  COURSE_PROFILE = 'course-profile',
  COURSE_FILTER_CATEGORY = 'course-filter-category'
}

export interface ITerm<T = any> {
  type: Terms
  name: string
  enabled?: boolean
  position?: number
  custom?: T
  _id: string
}

export type ITermParamsCreate = Omit<ITerm, 'id' | '_id'>

export interface ITermParamsUpdate extends Partial<Omit<ITerm, '_id'>> {
  id: string
}

export interface ITermParamsUpdateMany {
  terms: ITermParamsUpdate[]
}

export interface ITermParamsGetByType {
  type: Terms
}

export interface ITermParamsGetById {
  id: string
}

export interface ITermParamsDelete {
  id: string
}

export interface ITermParamsList {
  pageNumber?:string, // Numero de pagina
  nPerPage?:string, // Cantidad de elementos por pagina
  select?: string, // Campos de la colección a buscar
  search?:string, // Busca sobre los campos de la colección
  type?: Terms,
  types?: Terms[]
  enabled?: boolean
}
